import { render, staticRenderFns } from "./CommissionTable.vue?vue&type=template&id=2827db4f&scoped=true"
import script from "./CommissionTable.vue?vue&type=script&lang=js"
export * from "./CommissionTable.vue?vue&type=script&lang=js"
import style0 from "./CommissionTable.vue?vue&type=style&index=0&id=2827db4f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2827db4f",
  null
  
)

export default component.exports